import { render, staticRenderFns } from "./CheckAdditionalFields.vue?vue&type=template&id=4c80c900&scoped=true"
import script from "./CheckAdditionalFields.vue?vue&type=script&lang=js"
export * from "./CheckAdditionalFields.vue?vue&type=script&lang=js"
import style0 from "./CheckAdditionalFields.vue?vue&type=style&index=0&id=4c80c900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c80c900",
  null
  
)

export default component.exports